// Fix mobile menu - make Collections text trigger dropdown
document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuLinks = document.querySelectorAll('.m-menu-mobile__link');
  
  mobileMenuLinks.forEach(function(link) {
    const toggleButton = link.nextElementSibling;
    
    // Check if there's a toggle button next to the link
    if (toggleButton && toggleButton.classList.contains('m-menu-mobile__toggle-button')) {
      link.addEventListener('click', function(e) {
        // Prevent default navigation
        e.preventDefault();
        // Trigger the toggle button click instead
        toggleButton.click();
      });
    }
  });
});
